// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"222":"a9c5b28e","238":"7c640520","249":"3de8e344","317":"9d1a7766","838":"a8800154"}[chunkId] + ".js";
};